import { useState, useEffect } from "react";
import camisas from "../data/camisas";
import CardCamisa from "../components/CardCamisa/CardCamisa";
import ModalCamisa from "../components/ModalCamisa/ModalCamisa";

export default function CopaDoMundo() {
  const [camisaSelecionada, setCamisaSelecionada] = useState(null);

  const bandeiras = {
    "africa-do-sul": "https://flagcdn.com/w80/za.png",
    alemanha: "https://flagcdn.com/w80/de.png",
    "arabia-saudita": "https://flagcdn.com/w80/sa.png",
    argentina: "https://flagcdn.com/w80/ar.png",
    argelia: "https://flagcdn.com/w80/dz.png",
    australia: "https://flagcdn.com/w80/au.png",
    belgica: "https://flagcdn.com/w80/be.png",
    brasil: "https://flagcdn.com/w80/br.png",
    canada: "https://flagcdn.com/w80/ca.png",
    chile: "https://flagcdn.com/w80/cl.png",
    colombia: "https://flagcdn.com/w80/co.png",
    croacia: "https://flagcdn.com/w80/hr.png",
    curacao: "https://flagcdn.com/w80/cw.png",
    eau: "https://flagcdn.com/w80/ae.png",
    equador: "https://flagcdn.com/w80/ec.png",
    egito: "https://flagcdn.com/w80/eg.png",
    escocia: "https://flagcdn.com/w80/gb-sct.png",
    espanha: "https://flagcdn.com/w80/es.png",
    eua: "https://flagcdn.com/w80/us.png",
    franca: "https://flagcdn.com/w80/fr.png",
    gana: "https://flagcdn.com/w80/gh.png",
    haiti: "https://flagcdn.com/w80/ht.png",
    holanda: "https://flagcdn.com/w80/nl.png",
    hungria: "https://flagcdn.com/w80/hu.png",
    inglaterra: "https://flagcdn.com/w80/gb-eng.png",
    jordania: "https://flagcdn.com/w80/jo.png",
    marrocos: "https://flagcdn.com/w80/ma.png",
    mexico: "https://flagcdn.com/w80/mx.png",
    noruega: "https://flagcdn.com/w80/no.png",
    "nova-zelandia": "https://flagcdn.com/w80/nz.png",
    "pais-de-gales": "https://flagcdn.com/w80/gb-wls.png",
    paraguai: "https://flagcdn.com/w80/py.png",
    portugal: "https://flagcdn.com/w80/pt.png",
    qatar: "https://flagcdn.com/w80/qa.png",
    "republica-tcheca": "https://flagcdn.com/w80/cz.png",
    senegal: "https://flagcdn.com/w80/sn.png",
    suecia: "https://flagcdn.com/w80/se.png",
    suica: "https://flagcdn.com/w80/ch.png",
    tunisia: "https://flagcdn.com/w80/tn.png",
    ucrania: "https://flagcdn.com/w80/ua.png",
    uruguai: "https://flagcdn.com/w80/uy.png",
    venezuela: "https://flagcdn.com/w80/ve.png",
  };

  useEffect(() => {
    document.title = "Copa do Mundo 26 | Piazada dos Mantos";
  }, []);

  const scrollPara = (selecao) => {
    const el = document.getElementById(selecao);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    const flag = document.querySelector(`[data-flag="${selecao}"]`);
    if (flag) {
      flag.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  };

  const camisasSelecao = camisas.filter((c) => c.tipo === "copa-do-mundo");

  const agrupado = camisasSelecao.reduce((acc, camisa) => {
    if (!acc[camisa.selecao]) acc[camisa.selecao] = [];
    acc[camisa.selecao].push(camisa);
    return acc;
  }, {});

  const formatarNome = (nome) =>
    nome.replaceAll("-", " ").replace(/\b\w/g, (l) => l.toUpperCase());

  const renderGrid = (lista) => (
    <div className="grid">
      {lista.map((camisa) => (
        <CardCamisa
          key={`${camisa.selecao}-${camisa.id}`}
          camisa={camisa}
          onClick={setCamisaSelecionada}
        />
      ))}
    </div>
  );

  return (
    <div className="container">
      {/* HERO */}
      <section className="hero-copa">
        <div className="hero-copa-overlay">
          <h1>Copa do Mundo 2026</h1>
        </div>
      </section>

      <div className="flags-grid">
        {Object.keys(agrupado).map((selecao) => (
          <div
            key={selecao}
            className="flag-item"
            onClick={() => scrollPara(selecao)}
          >
            <img src={bandeiras[selecao]} alt={selecao} />
            <span>{formatarNome(selecao)}</span>
          </div>
        ))}
      </div>

      {Object.keys(agrupado)
        .sort()
        .map((selecao) => (
          <div key={selecao} id={selecao}>
            <h2 className="section-title">{formatarNome(selecao)}</h2>

            {renderGrid(agrupado[selecao])}
          </div>
        ))}

      {/* MODAL */}
      {camisaSelecionada && (
        <ModalCamisa
          camisa={camisaSelecionada}
          onClose={() => setCamisaSelecionada(null)}
        />
      )}
    </div>
  );
}
